import { render } from "./ListaServicos.vue?vue&type=template&id=56444ac6"
import script from "./ListaServicos.vue?vue&type=script&lang=js"
export * from "./ListaServicos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__